import { API_URL } from "../constants/api";
import { utils_api } from "../utils/utils_api";

export const api_usps_subscriptions = {
  get_all(success, fail) {
    return utils_api.auth_get(
      `/${API_URL.ORDERS_USPS_SUBSCRIBE}`,
      success,
      fail,
    );
  },
  subscribe(success, fail, mid) {
    return utils_api.auth_post(
      `/${API_URL.ORDERS_USPS_SUBSCRIBE}`,
      { mid },
      success,
      fail,
    );
  },
  unsubscribe(success, fail, subscription_id) {
    return utils_api.auth_delete(
      `/${API_URL.ORDERS_USPS_SUBSCRIBE_DELETE(subscription_id)}`,
      null,
      success,
      fail,
    );
  },
};
